require('brace/mode/markdown')
ace.define("ace/mode/qsyntax_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules","ace/mode/javascript_highlight_rules","ace/mode/xml_highlight_rules","ace/mode/html_highlight_rules","ace/mode/css_highlight_rules","ace/mode/markdown_highlight_rules"], function(acequire, exports, module) {
  "use strict";

  var oop = acequire("../lib/oop");
  var lang = acequire("../lib/lang");
  var MarkdownHighlightRules = acequire("./markdown_highlight_rules").MarkdownHighlightRules;

  var escaped = function(ch) {
    return "(?:[^" + lang.escapeRegExp(ch) + "\\\\]|\\\\.)*";
  };

  var QsyntaxHighlightRules = function() {
    MarkdownHighlightRules.call(this);
    this.$rules["start"].unshift({
      token : "divider_hard",
      regex : /^===+$/
    }, {
      token : "divider_soft",
      regex : /^---+$/
    }, {
      token : "divider_metadata",
      regex : /^~~~+$/
    }, {
      token : ["text", "mathlive", "text"],
      regex : /(math_)(.*?)(_math)/
    },
    { // select
     token : ["constant", "point", "constant", "label", "constant"],
     regex : /^(\$)([0-9]*\s*)(\[)(.*?)(\])$/,
    }, { // checkbox
      token : ["constant", "point", "constant"],
      regex : /^(\$)([0-9]*\s*)(\[\s*\])/,
      next: "checkbox_label"
    }, { // radio
      token : ["constant", "point", "constant"],
      regex : /^(\$)([0-9]*\s*)(\(\s*\))/,
      next: "checkbox_label"
    }, { // multi checkbox option
      token : ["constant", "correct", "constant"],
      regex : /^(\$)(\*\s*)(\[\s*\])/,
      next: "checkbox_label"
    }, { // multi checkbox point
      token : ["constant", "correct", "point"],
      regex : /^(\$)(\*\s*)([0-9]+\s*)$/
    }, { // inline_select
      token : ["constant"],
      regex : /(\$\(\*\s*)/,
      next: "inline_select_labels"
    }, { // textarea
      token : ["constant", "textarea"],
      regex : /^(\$)(\s*=+)$/
    }, { // textarea with label
      token : ["constant", "constant"],
      regex : /^(\$)(\(\s*)(?=\[)/,
      next: "textarea_labels"
    }, { // textfield
      token : ["constant", "textfield"],
      regex : /(\$)(_+)/
    }, { // textfield with label
      token : ["constant", "constant"],
      regex : /(\$)(\()/,
      next: "input_label"
    }, {
      token : "constant",
      regex : /^\+.*/,
    }, {
      token : ["keyword", "constant"],
      regex : /^(\s\s-\s.*)(\$)/,
      next: "grading_score"
    }, {
      token : "keyword",
      regex : /^(\s\s-\s.*)/,
    })

    // 採点の編集が動かないため、コメントします。
    this.addRules({
      "textarea_labels": [{
        token: ["bracket", "label", "constant", "point", "bracket"],
        regex: /(\[)(.+?)(\,\s*)([0-9"A-z\s]+)(\])/
      }, {
        token: "constant",
        regex: /\)/,
        next: "textarea"
      }],
      "textarea": [{
        token: "textarea",
        regex: /=+\s*$/,
        next  : "start"
      }],
      "checkbox_label": [{
        token: "text",
        regex: /$/,
        next : "start"
      }, {
        token : ["text", "mathlive", "text"],
        regex : /(math_)(.*?)(_math)/,
        next: "start"
      }],
      "input_label": [
        {
          token : ["text", "text", "mathlive", "text", "text","constant"],
          regex : /(.*?)(math_)(.*?)(_math)(.*?)(\s*\|\s*)/,
          next: "end_input"
        },
        {
          token: ["label", "constant"],
          regex: /(.+?)(\s*\|\s*)/,
          next: "end_input"
      }
      ],
      "end_input": [{
        token: ["point", "constant", "textfield"],
        regex: /([0-9]+)(\))(_+)/,
        next: "start"
      }],
      "inline_select_labels": [{
        token: ["bracket", "label", "constant", "point", "bracket"],
        regex: /(\[)(.+?)(\,\s*)([0-9]+)(\])/
      }, {
        token: "constant",
        regex: /\)/,
        next: "inline_select"
      }
    ],
    "inline_select": [{
      token: "textarea",
      regex: /_+\s*$/,
      next  : "start"
    }],
    "grading_score": [{
      token: ["bracket", "label", "constant", "point", "bracket"],
      regex: /(\[)(.+?)(\,\s*)([0-9]+)(\])/,
    }, {
      token: "constant",
      regex: /\)/,
      next: "start"
    }]
    })
  }
  oop.inherits(QsyntaxHighlightRules, MarkdownHighlightRules);
  exports.QsyntaxHighlightRules = QsyntaxHighlightRules;
})

ace.define("ace/mode/qsyntax",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript","ace/mode/xml","ace/mode/html","ace/mode/qsyntax_highlight_rules","ace/mode/folding/markdown"], function(acequire, exports, module) {
  "use strict";

  var oop = acequire("../lib/oop");
  var MarkdownMode = acequire("./text").Mode;
  var QsyntaxHighlightRules = acequire("./qsyntax_highlight_rules").QsyntaxHighlightRules;
  var MarkdownFoldMode = acequire("./folding/markdown").FoldMode;

  var Mode = function() {
    this.HighlightRules = QsyntaxHighlightRules;
    this.foldingRules = new MarkdownFoldMode();
    this.$behaviour = this.$defaultBehaviour;
  };
  oop.inherits(Mode, MarkdownMode);

  (function() {
    this.type = "text";
    this.blockComment = {start: "<!--", end: "-->"};

    this.getNextLineIndent = function(state, line, tab) {
      if (state == "listblock" || state == "start") {
        var match = /^(\s*)(?:([-+*])|(\d+)\.)(\s+)/.exec(line);
        if (!match)
          return "";
        var intent = match[1];
        var marker = match[2];
        if (!marker)
          marker = parseInt(match[3], 10) + 1 + ".";
        else if (marker == "+") {
          marker = "-"
          intent = intent + "  "
        }

        return intent + marker + match[4];
      } else {
        return this.$getIndent(line);
      }
    };
    this.$id = "ace/mode/qsyntax";
  }).call(Mode.prototype);

  exports.Mode = Mode;
  });
